import { PARAM_URL_UTM_ORIGIN } from "~/constants";
import { ExtraInformation, getEnvVar } from "@commons-monorepo/index";

const FB_PIXEL_STORAGE_KEY = "sumer_fb_pixel_id";

const getStoredFacebookPixelId = () => {
  if (typeof window === "undefined") return "";
  try {
    return window.sessionStorage.getItem(FB_PIXEL_STORAGE_KEY) || "";
  } catch (error) {
    console.error("Failed to read facebook pixel id", error);
    return "";
  }
};

export const goToCheckout = (
  partnerUrl: string,
  cartId: string,
  token?: string,
  options?: {
    isPrime?: boolean;
    referrer?: string | null;
    source?: string | null;
    utmOrigin?: string | null;
    skipCart?: boolean | null;
    serviceInfo?: ExtraInformation;
  },
) => {
  const env = getEnvVar("PUBLIC_ENV");
  const siteUrl = getEnvVar("PUBLIC_HOST");
  const url = window.location.href;
  const params = new URLSearchParams();
  !!token && params.set("accessToken", token);

  options?.isPrime &&
    url.indexOf(`//${partnerUrl}.`) < 0 &&
    params.set("prime", "false");
  options?.referrer && params.set("referrer", options.referrer);
  options?.source && params.set("source", options.source);
  options?.utmOrigin && params.set(PARAM_URL_UTM_ORIGIN, options?.utmOrigin);

  options?.serviceInfo &&
    params.set("serviceInfo", JSON.stringify(options?.serviceInfo || null));

  const facebookPixelId = getStoredFacebookPixelId();
  if (facebookPixelId) {
    params.set("fbpid", facebookPixelId);
  }

  const checkoutHost = getEnvVar("PUBLIC_CHECKOUT_HOST", false);
  const origin =
    env === "local" ? checkoutHost || siteUrl : window.location.origin;

  const urlRedirect = `${origin}/checkout/${partnerUrl}/${cartId}${
    options?.skipCart ? "/customer" : ""
  }?${params.toString()}`;

  window.location.href = urlRedirect;
};
